module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADAAAAAwCAMAAABg3Am1AAAAQlBMVEUAAAAiIiwmJC4SEjAmJS4mJS4lJS0lJS0lJS0gIDAmJS4lJS4lJCwlJTAmJS4mJS0lJS0lJS4nJC4mJi0lJS8mJS4J679sAAAAFXRSTlMAGs0F8+vbmEQQ47NfMMa0fHtwUEwHiGAOAAAA3ElEQVRIx+2UyxaDIAxE5aWCiory/7/agj1Rm0Ogi9YunI1RZ0K4i1RXqTem/8AuGv9UI0r9jPsozsr8rfIvqbbEP0dvXcfHnLXrLhpHrcdYdJr2D1vjKdTTdtRA0pQwOlxG9gRNgAO4CL7oN2oBwgPgIZM0hwSGOUUTdwK+KZpYmO9yGJS43gIf1I6CAqjgnYB94nsKVBldGFiNP8is2cDm3xPZgH/TVwJQ34E78H+BsJYYbWJhMUHAhlXIqAALq9RCwPkiOQgIXuLn4rQKSeFVKpyVlFtaJ6of6QHKlTi3TY9u+wAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/supplychain/home_pre.png
// module id = ka4S
// module chunks = 44